<div class="schedule-container">
  @if (schedule?.startHour && schedule?.endHour) {
    <span><strong>{{ 'openingHours' | translate }}: </strong>
      @if (onNewLine) {
        <br>
      }
      {{ schedule?.startHour }} - {{ schedule?.endHour }}
    </span>
    <br>
  }
  @if (schedule?.lunchBreakStart && schedule?.lunchBreakEnd) {
    <span><strong>{{ 'lunchBreak' | translate }}: </strong>
      @if (onNewLine) {
        <br>
      }
      {{ schedule?.lunchBreakStart }} - {{ schedule?.lunchBreakEnd }}
    </span>
  }
</div>
